import React from 'react';
import SEO from './components/SEO';

const wmtcRulesUrl = "https://drive.google.com/file/d/1JqJaZojhguvk9mQKhPpjsRMPJsQhhGeB/view";
const wmtcRegistrationFormUrl = "https://forms.gle/HSbz99X2c9dXt9KU8";

export default function WMTCPage() {
  // SEO Data for WMTC page
  const seoData = {
    title: "WMTC",
    description: "Join the World Mathematics Team Championship (WMTC) - Pakistan's qualifying competition for international mathematics team championships. Register now for 2025.",
    keywords: "World Mathematics Team Championship, WMTC Pakistan, mathematics team competition, Pakistan math team, international mathematics competition, WMTC registration 2025",
    url: "https://capstonepakistan.org/competitions/wmtc"
  };

  return (
    <>
      <SEO {...seoData} />
    <div className="min-h-screen bg-white">
      {/* Hero Section - Dynamic Design */}
      <section className="relative py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-blue-500" />
        
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-center">
            <img src="/wmtclogo.png" alt="WMTC Logo" className="w-32 h-32 object-contain rounded-full mx-auto mb-8 border-4 border-white shadow-2xl bg-white" />
            <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              World Mathematics Team Championship
            </h1>
            <h2 className="text-2xl lg:text-3xl font-semibold mb-6 text-white/90">Pakistan Math Team Selection</h2>
            <p className="text-xl lg:text-2xl text-white/90 leading-relaxed max-w-4xl mx-auto">
              The official National Competition designed to serve as the qualifying stage for the World Mathematics Team Championship (WMTC)
            </p>
          </div>
        </div>
      </section>

      {/* About Section - Dynamic Design */}
      <section className="relative py-20 lg:py-32 overflow-hidden bg-white">
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="bg-white rounded-[20px] p-8 lg:p-12 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
            <h2 className="text-3xl lg:text-4xl font-bold text-black mb-6 text-center">About WMTC</h2>
            <div className="space-y-6 text-lg text-black leading-relaxed">
              <p>
                The Pakistan Mathematics Team Champion is the official National Competition designed to serve as the qualifying stage for the World Mathematics Team Championship (WMTC).
              </p>
              <p>
                Following the competition, the top participants will be selected and appointed as members of the Pakistan Mathematics Team for WMTC. This team will be representing Pakistan in the WMTC 2024. Participants' performance in the competition will be evaluated for recognition, which may include distinctions such as Individual Awards, Team Awards and Scholarships.
              </p>
              <p>
                In 2009, Mr. Quan K. Lam met with Mr. Zhou Guozhen for a proposal organizing a mathematics competition in Beijing. This competition would differ from many other mathematics competitions such as American Mathematics Competitions (AMC) and International Math Olympiad (IMO). It would be a team–oriented competition where competing students from all over the world, forming their own teams, stay in a central location for several days.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* WMTC Guide Section */}
      <section className="py-20 bg-blue-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              WMTC Guide
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Everything you need to know about participating in the World Mathematics Team Championship
            </p>
          </div>
          
          <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 text-center">
            <div className="w-24 h-24 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Complete WMTC Guide</h3>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Download our comprehensive guide that covers everything from registration to competition format, preparation strategies, and what to expect during the World Mathematics Team Championship.
            </p>
            <a 
              href="https://drive.google.com/file/d/1JqJaZojhguvk9mQKhPpjsRMPJsQhhGeB/view?usp=sharing" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              Download WMTC Guide
            </a>
          </div>
        </div>
      </section>

      {/* Light Background Section - Competition Overview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Competition Overview
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              A unique team-oriented competition bringing together students from around the world
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Team-Based</h3>
              <p className="text-gray-600">Students form teams and compete together in a collaborative environment</p>
            </div>
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">International</h3>
              <p className="text-gray-600">Students from around the world compete and share cultural experiences</p>
            </div>
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Multi-Day Event</h3>
              <p className="text-gray-600">Extended competition with tours, cultural activities, and academic challenges</p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section - Dynamic Design */}
      <section className="relative py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-red-600 via-orange-600 to-yellow-600" />
        
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Watch WMTC in Action
            </h2>
            <p className="text-xl lg:text-2xl text-white/90 leading-relaxed max-w-3xl mx-auto">
              Experience the excitement and international collaboration of the World Mathematics Team Championship
            </p>
          </div>
          
          <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
            <iframe 
              className="w-full h-96 rounded-[20px]" 
              src="https://www.youtube.com/embed/Kr8dnoYlcII" 
              title="World Mathematics Team Championship"
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
            />
            <div className="mt-6 text-center">
              <h4 className="text-2xl font-bold text-gray-900 mb-2">World Mathematics Team Championship</h4>
              <p className="text-gray-700">Experience the excitement and international collaboration of the World Mathematics Team Championship.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Light Background Section - Quick Actions */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Get Started with WMTC
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Everything you need to participate in the World Mathematics Team Championship
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-6">
            <a 
              href={wmtcRegistrationFormUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-white rounded-[20px] px-8 py-6 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transition-all duration-300 text-center"
            >
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
              </div>
              <div className="font-bold text-xl text-gray-900 mb-2">Registration Form</div>
              <div className="text-gray-600">Register for WMTC</div>
            </a>
            <a 
              href={wmtcRulesUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-white rounded-[20px] px-8 py-6 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transition-all duration-300 text-center"
            >
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
              </div>
              <div className="font-bold text-xl text-gray-900 mb-2">WMTC Rules</div>
              <div className="text-gray-600">Competition guidelines</div>
            </a>

            <a 
              href="https://docs.google.com/forms/d/e/1FAIpQLSc5ehpIcyftzyjp_8YAgPVIzr_f0R4coX91FXhGVqEBtA_6zQ/viewform?usp=sf_link" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-white rounded-[20px] px-8 py-6 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transition-all duration-300 text-center"
            >
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                </svg>
              </div>
              <div className="font-bold text-xl text-gray-900 mb-2">Campus Ambassador</div>
              <div className="text-gray-600">Join our program</div>
            </a>
          </div>
        </div>
      </section>

      {/* Registration & Events Section - Dynamic Design */}
      <section className="relative py-20 lg:py-32 overflow-hidden bg-white">
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-6xl font-bold text-black mb-6 leading-tight">
              Registration & Events
            </h2>
            <p className="text-xl lg:text-2xl text-black leading-relaxed max-w-3xl mx-auto">
              Important information about registration and competition events
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* Registration Guide */}
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Registration Guide</h3>
              </div>
              <div className="space-y-4 text-gray-700">
                <p>Students from each group (consisting of 4 or less students enrolled in the same school) must register for the competition individually or together and enter the name of their group leader.</p>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3 mt-2"></div>
                    <span><strong>Individual Registration:</strong> Fill out the registration form, enter your own name as group leader. There is no registration fee.</span>
                  </div>
                </div>
                <p className="font-semibold">Confirmation will be sent within 48 hours. Registration deadline: <span className="text-red-600">30th October 2024</span>.</p>
              </div>
            </div>
            
            {/* Events Schedule */}
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Events Schedule</h3>
              </div>
              <div className="space-y-3">
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                  <span className="text-gray-700"><strong>Nov 27-28:</strong> Coaches and Proctors meeting, Registration, Welcome meeting</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                  <span className="text-gray-700"><strong>Nov 29:</strong> Individual rounds, Relay Rounds, Team Rounds</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                  <span className="text-gray-700"><strong>Nov 30:</strong> Tours, Cultural Night, Committee meeting</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                  <span className="text-gray-700"><strong>Dec 1:</strong> Tie breaker, Awards ceremony, Student Showcase</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Light Background Section - Rewards */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Rewards & Recognition
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Comprehensive awards system recognizing individual and team achievements
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Individual Awards</h3>
              <div className="space-y-4 text-gray-700">
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mr-3 mt-2"></div>
                  <span><strong>Gold Medals:</strong> Top 10% of participants</span>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mr-3 mt-2"></div>
                  <span><strong>Silver Medals:</strong> Next 20% of participants</span>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mr-3 mt-2"></div>
                  <span><strong>Bronze Medals:</strong> Next 30% of participants</span>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mr-3 mt-2"></div>
                  <span><strong>Merits Certificates:</strong> Next 20% of participants</span>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mr-3 mt-2"></div>
                  <span><strong>Participation Certificates:</strong> Last 20% of participants</span>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Scholarships & Team Awards</h3>
              <div className="space-y-4 text-gray-700">
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-green-600 rounded-full mr-3 mt-2"></div>
                  <span><strong>Individual Scholarships:</strong> First Place US$ 300, Second Place US$ 200, Third Place US$ 100, 4th Place US$ 50</span>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-green-600 rounded-full mr-3 mt-2"></div>
                  <span><strong>Team Awards:</strong> Top 30% teams get trophies or plaques</span>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-green-600 rounded-full mr-3 mt-2"></div>
                  <span><strong>Relay Scholarships:</strong> Top team gets US$ 180 scholarship</span>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-green-600 rounded-full mr-3 mt-2"></div>
                  <span><strong>Leadership Recognition:</strong> Team Leader and Group Leader certificates</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Campus Ambassador Section - Dynamic Design */}
      <section className="relative py-20 lg:py-32 overflow-hidden bg-white">
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-6xl font-bold text-black mb-6 leading-tight">
              Campus Ambassador Program
            </h2>
            <p className="text-xl lg:text-2xl text-black leading-relaxed max-w-3xl mx-auto">
              Join our program and help promote academic excellence in your school!
            </p>
          </div>
          
          <div className="bg-white rounded-[20px] p-8 lg:p-12 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-2xl font-bold text-black mb-6">What You'll Do</h3>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-teal-600 rounded-full mr-3"></div>
                    <span className="text-black">Promote WMTC and other competitions in your school</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-teal-600 rounded-full mr-3"></div>
                    <span className="text-black">Help organize information sessions and workshops</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-teal-600 rounded-full mr-3"></div>
                    <span className="text-black">Assist students with registration and preparation</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-teal-600 rounded-full mr-3"></div>
                    <span className="text-black">Gain leadership experience and recognition</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-teal-600 rounded-full mr-3"></div>
                    <span className="text-black">Receive certificates and potential scholarships</span>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <a 
                  href="https://docs.google.com/forms/d/e/1FAIpQLSc5ehpIcyftzyjp_8YAgPVIzr_f0R4coX91FXhGVqEBtA_6zQ/viewform?usp=sf_link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-block px-8 py-4 bg-teal-600 hover:bg-teal-700 text-white font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                >
                  Apply Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section - Dynamic Design */}
      <section className="relative py-20 lg:py-32 overflow-hidden bg-white">
        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-6xl font-bold text-black mb-6 leading-tight">
            Get in Touch
          </h2>
          <p className="text-xl lg:text-2xl text-black leading-relaxed max-w-3xl mx-auto mb-12">
            Have questions? We're here to help you succeed in WMTC 2024
          </p>
          <a 
            href="mailto:admin@capstonepakistan.org" 
            className="inline-block px-8 py-4 bg-white hover:bg-gray-100 text-black font-semibold text-lg rounded-lg border-2 border-gray-900 transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          >
            Contact Us
          </a>
        </div>
      </section>
    </div>
    </>
  );
} 